import { Dot } from 'lucide-react';
import { Link } from 'react-router';

export const FooterLegalLinks = () => {
  return (
    <div className="flex flex-row items-center gap-px">
      <p className="text-xs leading-5">
        <Link to="/terms-of-service"
          className="text-muted-foreground text-xs hover:underline hover:text-muted-foreground/75"
        >
          Terms of Service
        </Link>
      </p>
      <Dot className="w-4" />
      <p className="text-xs leading-5">
        <Link to="/privacy-policy"
          className="text-muted-foreground text-xs hover:underline hover:text-muted-foreground/75"
        >
          Privacy Policy
        </Link>
      </p>
    </div>
  );
};
